type AnyRef<T> = ((node: T | null) => void) | { current: T | null } | null | undefined;

/** One callback ref that feeds several refs (React 19 passes `ref` as a prop). */
export function mergeRefs<T>(...refs: unknown[]): (node: T | null) => void {
  return (node: T | null) => {
    for (const ref of refs as Array<AnyRef<T>>) {
      if (typeof ref === 'function') ref(node);
      else if (ref && typeof ref === 'object') ref.current = node;
    }
  };
}
